export default __webpack_public_path__ + "static/ufo-d237c320688742194e97cbcac3da6fc0.png";